// Demo Opus — read-only inventory chat (Bebo engine, curated tools over a
// bundled snapshot). No brand, any authenticated user. Mirrors api/analyst.js.

// Streaming (SSE) query. Bypasses axios to read the response body incrementally.
// Calls onStatus(tool) before each tool runs and onDelta(text) for each chunk.
export async function streamQuery(
  question,
  { history, onStatus, onDelta, onError, signal } = {}
) {
  const token = (() => {
    try {
      return window.localStorage.getItem('access_token');
    } catch (_e) {
      return null;
    }
  })();
  const base = process.env.REACT_APP_API_URL || '';
  const authorization = token
    ? token.startsWith('Bearer ')
      ? token
      : `Bearer ${token}`
    : undefined;

  const resp = await fetch(`${base}/demo/opus/stream`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      ...(authorization ? { Authorization: authorization } : {}),
    },
    body: JSON.stringify({ question, history: history || [] }),
    signal,
  });

  if (!resp.ok || !resp.body) {
    throw new Error(`stream failed: ${resp.status}`);
  }

  const reader = resp.body.getReader();
  const decoder = new TextDecoder();
  let buffer = '';
  let terminated = false;

  for (;;) {
    // eslint-disable-next-line no-await-in-loop
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    const parts = buffer.split('\n\n');
    buffer = parts.pop() ?? '';
    for (const part of parts) {
      const line = part.trim();
      if (!line.startsWith('data:')) continue; // skips heartbeat comment lines (": ping")
      let evt;
      try {
        evt = JSON.parse(line.slice(5).trim());
      } catch (_e) {
        continue;
      }
      if (evt.type === 'delta') onDelta?.(evt.text);
      else if (evt.type === 'status') onStatus?.(evt.tool);
      else if (evt.type === 'done') terminated = true;
      else if (evt.type === 'error') {
        terminated = true;
        onError?.(evt.message);
      }
    }
  }

  if (!terminated && !signal?.aborted) {
    onError?.('La respuesta se cortó antes de terminar. Probá de nuevo.');
  }
}

// Human labels for the tool-status chips shown while the model works.
export const TOOL_LABELS = {
  estadisticas_generales: 'el panorama general',
  listar_familias: 'las familias de artículos',
  buscar_articulo: 'el catálogo de artículos',
  stock_articulo: 'el stock',
  top_articulos_vendidos: 'los más vendidos',
  ventas_por_familia: 'las ventas por familia',
  resumen_tipos_movimiento: 'los tipos de movimiento',
  movimientos_articulo: 'el historial del artículo',
  ficha_cliente: 'la ficha del cliente',
  articulos_por_proveedor: 'los datos del proveedor',
};
